import { Vue, Prop, Component } from 'vue-property-decorator'
import { VBtn, VCol, VIcon, VRow, VSpacer } from 'vuetify/lib'

@Component({})
export class ToolbarTitle extends Vue {
	@Prop({ type: String, required: true }) title!: string
	@Prop({ type: String }) subtext!: string
	@Prop({ type: Boolean, default: false }) backButton!: boolean

	get firstTitle() {
		const texts = this.title.split(' ')
		if (texts.length == 0) return ''

		const text = texts[0]
		return text
	}

	get secondaryText() {
		const text = this.title.replaceAll(this.firstTitle, '')
		return text
	}

	public render() {
		return (
			<VRow class="d-flex" align="center">
				{this.backButton && (
					<VBtn icon onClick={() => this.$emit('click:back')} large>
						<VIcon>mdi-arrow-left</VIcon>
					</VBtn>
				)}
				<VCol cols="6">
					<h2 class="atta-title">
						{this.firstTitle}
						<strong>{this.secondaryText}</strong>
						{this.subtext && <small class="d-block">{this.subtext}</small>}
					</h2>
				</VCol>
				<VSpacer />
				{this.$scopedSlots.default ? <div>{this.$scopedSlots.default(this.$props)}</div> : ''}
			</VRow>
		)
	}
}

export default ToolbarTitle
